export default __webpack_public_path__ + "static/media/Navidad(1140x475).2e4b7805.webp";